import { CartIcon } from './CartIcon';

/**
 * author: Google
 * id 97563623-CF1C-43AE-87D8-DF54802D442B
 * name cart
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart.svg
 * tags
 * - Shopping 
 */
export const ShoppingCartIcon = CartIcon;
export default ShoppingCartIcon